import React, { useEffect } from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticated, useAccount } from "@azure/msal-react";
import { loginRequest } from "./authconfig";
// import jwtDecode from "jwt-decode";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getUser, resetUser, setUser } from "./Store/Reducers/UserReducer";
import LoadingSpinner from './Layout Component/LoadingSpinner';
import Header from "./Layout Component/Header";
import { MdArrowRightAlt } from "react-icons/md";
import LoginFun from "./Layout Component/Loginfun";
import Swal from "sweetalert2";
import { setLoader } from "./Store/Reducers/UserReducer";

var CryptoJS = require("crypto-js");
export default function Home({ showSidebar }) {
    const url = process.env.REACT_APP_OXAR_API_URL
    const { useState, useEffect } = React;
    const { instance, accounts, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const dispatch = useDispatch();
    const [authToken, setAuthToken] = useState([]);
    const [istoken, setistoken] = useState(false);
    const [uname, setuName] = useState("");
    const LogoutMain = LoginFun();
    const LoginRedirectHandler = async () => {

        var CookiePolicyValue = localStorage.getItem("CookiePolicy");

        if (CookiePolicyValue == "false") {
            Swal.fire({
                title: 'Cookies Policy Issue',
                text: "You haven't enabled third party cookies in your browser,Please enable to continue.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Okay',
                cancelButtonText: 'Browser settings',
            }).then(result => {
                if (result.isConfirmed) {
                    return
                    //logout();
                }

                else if (
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    //this.LogOut();
                    window.open('#/cookiesdetails', '_blank');
                }
            })
        }

        else {
            try {

                dispatch(setLoader(true));
                const account = instance.getAllAccounts();
                instance.loginRedirect().then(response => {
                    dispatch(setLoader(false));
                }).catch((e) => {
                })
                dispatch(setLoader(false));

            } catch (err) {
            }
        }

    };
    useEffect(() => {

        dispatch(setLoader(false));

    }, []);
    const getToken = async () => {
        debugger
        if (accounts[0].idTokenClaims.jobTitle == "Consultant") { }
        try {
            dispatch(setLoader(true));
            var username = "test@contoso.com";
            var currentAccount = instance.getAccountByUsername(accounts[0].username);
            var silentRequest = {
                scopes: ["openid", "profile", "https://oxar.onmicrosoft.com/c7e3a74b-6465-4ef2-9700-3ab424414914/Write", "https://oxar.onmicrosoft.com/c7e3a74b-6465-4ef2-9700-3ab424414914/Read"],
                account: currentAccount,
                forceRefresh: false
            };

            const tokenResponse = await instance.acquireTokenSilent(silentRequest).catch(error => {
            });

            //  Set storage with dispatch in reducer//

            sessionStorage.setItem("AuthToken", tokenResponse.accessToken);
            setAuthToken(tokenResponse);
            // dispatch(setUser(tokenResponse));

            if (tokenResponse.accessToken != "") {
                sessionStorage.setItem('TOKEN', true);
                { localStorage.setItem("ISTOKEN", true) }
                setistoken(true);
                dispatch(setLoader(false));
            }

            // getProfileDetails();

        } catch (e) {
        }
    }
    const navigate = useNavigate();
    const TokenValue = localStorage.getItem("ISTOKEN")

    return (

        <>
            {/* Split brand + sign-in layout. Markup is presentational only:
                every handler and the TokenValue condition are unchanged. */}
            <div className="pp-auth">

                <section className="pp-auth__brand">
                    <img src="assets/img/oxar.png" className="imageforbg pp-auth__media" alt="" />

                    {/* <span className="pp-auth__eyebrow">
                        <i className="fa fa-lock" aria-hidden="true" />
                        Secure patient portal
                    </span> */}
                    <div>
                    </div>

                    <div>
                        <h1 className="pp-auth__headline">
                            OX.assisted
                            <em>reproduction</em>
                        </h1>
                        {/* <p className="pp-auth__sub">
                            Your appointments, results, documents and medical history &mdash;
                            in one place, shared securely with your clinic.
                        </p> */}
                    </div>

                    <div>
                    </div>

                    {/* <ul className="pp-auth__points">
                        <li><i className="fa fa-calendar-check" aria-hidden="true" /> Appointments</li>
                        <li><i className="fa fa-file-waveform" aria-hidden="true" /> Results &amp; documents</li>
                        <li><i className="fa fa-file-medical" aria-hidden="true" /> Medical history</li>
                    </ul> */}
                </section>

                <section className="pp-auth__panel">
                    <div className="pp-auth__card">
                        <span className="pp-auth__mark">
                            <i className="fa fa-heart-pulse" aria-hidden="true" />
                        </span>

                        <h2 className="pp-auth__title">Welcome back</h2>
                        <p className="pp-auth__hint">
                            Sign in with your account to continue, or register if
                            this is your first visit.
                        </p>

                        <div className="pp-auth__cta">
                            {
                                TokenValue == "false" || TokenValue == null &&
                                <>
                                    <div className="pp-auth__actions">
                                        <button type='button' className="  btn1 m-2" onClick={(e) => { LoginRedirectHandler() }} >
                                            Login <MdArrowRightAlt size={20} aria-hidden="true" />
                                        </button>
                                        <button type='button' className="  btn2 m-2" onClick={() => navigate('/register')}>Register</button>
                                    </div>
                                </>
                            }
                        </div>

                        <div className="pp-auth__divider">Before you start</div>

                        <p className="pp-auth__note">
                            <i className="fa fa-circle-info" aria-hidden="true" />
                            <span>
                                Sign-in needs cookies enabled in your browser. If you have
                                trouble getting in, use the Help link in the footer.
                            </span>
                        </p>
                    </div>
                </section>

            </div>
        </>
    );

}